import request from '@/utils/request';

export function getCrmRequests(params) {
  return request({
    url: '/admin/crm-requests',
    method: 'get',
    params,
  });
}

export function approveCrmRequest(id) {
  return request({
    url: '/admin/crm-requests/' + id + '/approve',
    method: 'post',
  });
}

export function rejectCrmRequest(id, reason) {
  return request({
    url: '/admin/crm-requests/' + id + '/reject',
    method: 'delete',
    data: { reason },
  });
}
